<template>
	<div class="tuto" v-hammer:tap="() => next()">
			
		<transition name="step" mode="out-in">
			<div v-if="step" class="step" :key="step.id">
				<div class="text">{{ step.text }}</div>
				<div v-if="step.illustration" class="illustration">
					<card :card="card" />
				</div>
				<div v-if="step.description" class="description">{{ step.description }}</div>
			</div>
		</transition>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import data_tuto from '@/data/tuto'
import Card from '@/components/game/card'
import Sounds from '@/js/sounds'

export default {
	name: 'tuto',
	data() {
		return {
			index: 0,
			card: {
				attributes: [
					{ type: 'attack', element: 'fire' },
					{ type: 'attack', element: 'electric' },
					{ type: 'defence', element: 'ice' }
				]
			}
		}
	},
	computed: {
		...mapGetters([ 'game', 'fight' ]),
		step() {
			return { ...data_tuto[this.index], id: this.index }
		}
	},
	methods: {
		next() {
			Sounds.play('button')
			this.index++
			if (this.index >= data_tuto.length) this.$emit('close')
		}
	},
	components: { Card }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'


.tuto
	absolute 0
	background-color alpha(dark, 100%)
	flex center center
	letter-spacing 1px
	transition opacity 0.25s easeOutQuart
	cursor pointer
	&.tuto-enter, &.tuto-leave-to
		opacity 0
	.step
		width 430px
		padding 32px
		text-align center
		line-height 28px
		transition 0.25s easeOutQuart
		&.step-enter
			transform translateX(-24px)
			opacity 0
		&.step-leave-to
			transform translateX(24px)
			opacity 0
		.illustration
			margin 32px 0 0 0
			width 100%
			text-align center
			>>> .card
				margin 0 auto
		.description
			margin 16px 0 0 0
			opacity 0.5
			font-size 2rem

</style>
